import { encryptStorage } from "./EncryptStorage";
import getUrl from "./urlConst";

const POST_SESSION_REDIRECT_KEY = "post_session_redirect_url";

// Shared by every open tab (localStorage), so activity in any tab keeps the session alive.
export const LAST_ACTIVITY_KEY = "last_activity_at";
export const IDLE_TIMEOUT_MS = 1000 * 60 * 15;

export function touchLastActivity() {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
  } catch (e) {
    console.warn("Unable to record last activity", e);
  }
}

// True when no tab has seen user activity within the idle timeout. A missing
// timestamp also counts as expired, so sessions left over from a closed browser
// (or from before this check existed) are not resumed silently.
export function isSessionIdleExpired() {
  try {
    const lastActivity = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
    if (!lastActivity) return true;
    return Date.now() - lastActivity > IDLE_TIMEOUT_MS;
  } catch (e) {
    return true;
  }
}

// Best effort: tell the API to revoke the refresh token. Logout never waits on it,
// and `keepalive` lets the request finish even though logout reloads the page.
export function revokeRefreshToken() {
  try {
    const token = encryptStorage.getItem("token");
    const refreshToken = encryptStorage.getItem("refreshToken");
    if (!refreshToken || typeof fetch !== "function") return;
    fetch(`${getUrl()}api/account/revoketoken`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, refreshToken }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    console.warn("Unable to revoke refresh token", e);
  }
}

export function saveSessionRedirectPath() {
  if (typeof window === "undefined") return;
  const path = window.location.pathname + window.location.search + window.location.hash;
  if (path && path !== "/" && path !== "/login" && path !== "/logout") {
    try {
      localStorage.setItem(POST_SESSION_REDIRECT_KEY, path);
    } catch (e) {
      console.warn("Unable to save session redirect path", e);
    }
  }
}

export function getAndClearSessionRedirectPath() {
  if (typeof window === "undefined") return null;
  try {
    const path = localStorage.getItem(POST_SESSION_REDIRECT_KEY);
    localStorage.removeItem(POST_SESSION_REDIRECT_KEY);
    if (path && typeof path === "string" && path.startsWith("/") && !path.startsWith("//")) {
      return path;
    }
  } catch (e) {
    console.warn("Unable to retrieve session redirect path", e);
  }
  return null;
}

export function clearAuthSession(preserveRedirect = false) {
  const selectedLanguage = localStorage.getItem("i18nextLng");
  const redirectPath = preserveRedirect ? localStorage.getItem(POST_SESSION_REDIRECT_KEY) : null;

  encryptStorage.clear();
  localStorage.clear();

  if (selectedLanguage) {
    localStorage.setItem("i18nextLng", selectedLanguage);
  }
  if (redirectPath) {
    localStorage.setItem(POST_SESSION_REDIRECT_KEY, redirectPath);
  }
}
